require("core-js");
require("./js/index");
require("./less/bootstrap/core-layout.less");
require("./less/font-awesome.less");
require("./less/adminlte-debug.less");
require("leaflet/dist/leaflet.css");
require("datatables.net-bs/css/dataTables.bootstrap.css");
require("datatables.net-select-bs/css/select.bootstrap.css");
require("datatables.net-buttons-bs/css/buttons.bootstrap.css");
require("datatables.net-rowgroup-bs/css/rowGroup.bootstrap.css");
require("./css/index.css");
